module.exports = __webpack_public_path__ + "static/media/dH20.5fb9e76b.svg";